import { forEach } from 'lodash';
import extractHashtags from './extract-hashtags';

export default function hashtagStrategy(contentBlock, callback) {
  const results = extractHashtags(contentBlock.getText());
  forEach(results, hashtag => callback(hashtag.indices[0], hashtag.indices[1]));
}



// WEBPACK FOOTER //
// ./app/components/text-editor/plugins/hashtag/hashtag-strategy.js